import React from 'react';
import { DateRangePicker } from 'rsuite';
import { startOfDay, endOfDay, addDays, subDays, subMonths, startOfMonth, endOfMonth, startOfWeek, endOfWeek } from 'date-fns';
import './DateRange.css';
import { useMediaQuery } from 'react-responsive';

const Ranges = [
    {
        label: 'Today',
        value: [startOfDay(new Date()), endOfDay(new Date())],
        placement: 'left',
    },
    {
        label: 'Yesterday',
        value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))],
        placement: 'left',
    },
    {
        label: 'Last 7 Days',
        value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())],
        placement: 'left',
    },
    {
        label: 'This Week',
        value: [startOfWeek(new Date(), { weekStartsOn: 1 }), new Date()], // Week starts on Monday
        placement: 'left',
    },
    {
        label: 'Last Week',
        value: [
            startOfWeek(subDays(new Date(), 7), { weekStartsOn: 1 }), // Previous week's start date (Monday)
            endOfWeek(subDays(new Date(), 7), { weekStartsOn: 1 })   // Previous week's end date (Sunday)
        ],
        placement: 'left',
    },
    {
        label: 'This Month',
        value: [startOfMonth(new Date()),new Date()],
        placement: 'left',
    },
    {
        label: 'Last Month',
        value: [
            startOfMonth(subMonths(new Date(), 1)),
            endOfMonth(subMonths(new Date(), 1))
        ],
        placement: 'left',
    }
];

export const DateRange = ({ selectedRange, setSelectedRange }) => {
    const handleSelect = (range) => {
        setSelectedRange(range);
    };

    const isSmallOrMedium = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <div className='bg-transparent p-1 py-0 border-md-start'>
            <DateRangePicker
                value={selectedRange}
                ranges={Ranges}
                showOneCalendar={isSmallOrMedium}
                onChange={handleSelect}
                className="custom-date-range-picker"
                placeholder="Select Date"
                style={{ width: 210, left: '1106.12px' }}
                isoWeek={true}
            />
        </div>
    );
};
